export function pad(value, n) {
    let string = String(value);
    if (string.length < n) {
        return "0".repeat(n - string.length) + string;
    }
    else {
        return string;
    }
}
